import React from "react";

export const SERVICE_ORDER_HELP_TITLE = "Ordens de Serviço";

export function ServiceOrderHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Enviar instruções do escritório para a
        equipe de campo. O operador recebe no tablet ou celular o que fazer,
        quando fazer, em qual fazenda e quem deve executar.
      </p>
      <p>
        <strong>Ao clicar em Nova Ordem de Serviço, você pode:</strong>
      </p>
      <ol>
        <li>
          Escolher o <strong>tipo de serviço</strong> — pulverização, calagem,
          plantio, colheita, preparo de solo, etc.
        </li>
        <li>
          Em <strong>aplicações</strong>, usar ou salvar <strong>receitas</strong>{" "}
          — carregue uma receita já salva ou salve a atual para reenviar depois
          com um clique.
        </li>
        <li>
          Informar o <strong>período estimado</strong> — data e hora de início e
          fim previstos para executar o serviço.
        </li>
        <li>
          Selecionar <strong>fazenda</strong> e, se quiser, <strong>talhões</strong>{" "}
          onde o trabalho será feito.
        </li>
        <li>
          Escolher o(s) <strong>operador(es)</strong> que receberão a ordem no
          app de campo.
        </li>
      </ol>
      <div className="service-order-help-audio-callout">
        <strong>Plantio — recomendação em mil sementes</strong>
        <p>
          Não use quilos de semente. Informe a cultivar, mil sementes por
          hectare (ex.: soja 280), o espaçamento entre linhas da plantadeira (o
          sistema calcula sementes por metro), sementes por embalagem em
          unidades (bag/sacas), PMS opcional (peso de mil sementes) e em que
          unidade o operador vai informar o abastecimento da plantadeira
          (sementes, quilos, sacas ou bag). Adubo em kg/ha, inoculante em
          litros de água por hectare e a recomendação de inoculante em texto
          livre. A quantidade em si o operador lança no app.
        </p>
      </div>
      <div className="service-order-help-audio-callout">
        <strong>Mensagem de áudio (opcional)</strong>
        <p>
          Grave um áudio reforçando tudo o que foi escrito — dosagens, talhão,
          cuidados ou orientações extras. O operador ouve no app antes de
          executar o serviço.
        </p>
      </div>
      <p>
        <strong>Agendar o envio (final do formulário):</strong>
      </p>
      <ul>
        <li>
          <strong>Enviar agora</strong> — a ordem aparece imediatamente no app
          do operador.
        </li>
        <li>
          <strong>Agendar envio</strong> — escolha data e hora para a ordem
          ficar visível no celular do operador (útil para programar trabalho
          do dia seguinte).
        </li>
      </ul>
      <p>
        <strong>Depois que o operador conclui:</strong> ele informa o horário
        real de execução no app. Na plataforma, o serviço fica registrado com
        produtos, descrição, áudio e histórico — pronto para consulta e
        cruzamento com rastreamento.
      </p>
    </>
  );
}
